'use strict';

var angular = require('angular');
var Sly = require('@sabre/sabre-avro-sly');
var SeasonalityReviewCalendarModal = function SeasonalityReviewCalendarModal(dataProvider) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/seasonality-review-calendar-modal.html'),
    scope: {
      displayedCalendar: '=',
      seasonalityType: '@'
    },
    controller: 'SeasonalityReviewCalendarModalController',
    link: function link(scope, element) {
      element.css('opacity', 0);
      element.on('shown.bs.modal', function () {
        loadData();
      });
      function initSly() {
        if (scope.displayedCalendar.visibleData === 'historical') {
          scope.startAt = 0;
        } else if (scope.displayedCalendar.visibleData === 'current') {
          scope.startAt = scope.years.length - 2;
        } else {
          scope.startAt = scope.years.length - 1;
        }
        var container = angular.element(element);
        var frame = container.find('#year-calendar-carousel');
        var wrap = frame.parent();
        var options = {
          horizontal: 1,
          itemNav: 'forceCentered',
          smart: 1,
          activateMiddle: 1,
          startAt: scope.startAt,
          easing: 'swing',
          // Buttons
          prev: wrap.find('.prev'),
          next: wrap.find('.next')
        };
        var sly = new Sly(frame, options);
        sly.init();
        element.css('opacity', '');
        sly.set('speed', 200);
      }
      function loadData() {
        dataProvider.getData(scope.displayedCalendar, scope.seasonalityType).then(function (data) {
          scope.dateToColorMap = data.dateToColorMap;
          scope.legend = data.legend;
          initSly();
        });
      }
    }
  };
};
SeasonalityReviewCalendarModal.$inject = ['SeasonalityReviewCalendarDataProviderService'];
module.exports = SeasonalityReviewCalendarModal;